module.exports = __webpack_public_path__ + "static/land_screens-52b138781bbe860288ba0a0a82064ad0.webp";